import { CampaignSettings } from './CampaignSettings';
import { OutboundConfigurations } from './OutboundConfigurations';
import CRMIntegration from './CRMIntegration';

export default function SettingsContent() {
  return (
    <div className="p-4 space-y-6">
      <CRMIntegration />
      <OutboundConfigurations />
      <CampaignSettings />
    </div>
  );
}
